import React, { Component } from "react";
import { connect } from 'react-redux';
import { actionCreators } from '../actions/events';
import { createMuiTheme } from '@material-ui/core/styles';
import themes, { overrides } from '../themes';
import { actionCreators as actionCreatorsRegisters }  from '../actions/registers';
import '../styles/Events.css';
import '../styles/EventsHistory.css';

import EventsChart from './EventsChart';
import EventsHistoryTable from './EventsHistoryTable';
import RegisterHistoryTable from './RegisterHistoryTable';
import ManufacturerRegisterHistoryTable from './ManufacturerRegisterHistoryTable';
import RealtimeDatafeedTable from "./RealtimeDatafeedTable";

 class EventInstanceHistoryComponent extends Component {

  constructor(props){
    super(props);
    this.state = {
      days: 7,
      selected: "7d"
    }
  }

  handleSort = (events) => {
    const eventsAfter = events.sort((a, b) => new Date(b.created) - new Date(a.created));
    return eventsAfter;
  }

  handleChange = (value) => {
    if(value === "7d"){
      this.props.requestEventsTagInstance(this.props.match.params.id, this.props.match.params.tag, 7);
      this.setState({ days: 7, selected: "7d"});

    }else if(value === "1d"){
      this.props.requestEventsTagInstance(this.props.match.params.id, this.props.match.params.tag, 1);
      this.setState({ days: 1, selected: "1d" });
    }else{
      this.props.requestEventsTagInstance(this.props.match.params.id, this.props.match.params.tag, 15);
      this.setState({ days: 15,  selected: "15d" });
    }
  } 


  componentDidMount() {
    this.props.requestEventsTagInstance(this.props.match.params.id, this.props.match.params.tag, this.state.days);
    this.props.requestRegistersTagInstance(this.props.match.params.id, this.props.match.params.tag);
    this.props.requestManufacturerCommsFailureRegisters(this.props.match.params.id);
    this.props.requestRealtimeDatafeedRegisters(this.props.match.params.id);
  }


  render() {
    if(this.props.match.params.tag.includes("comms-failure")){
      return (
        <div  className='EventsTable-Wrapper'>
          <h1 className='EventValuesH1'>Values History {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
          <RegisterHistoryTable registers = {this.props.registers} instance = {this.props.instance} isHistory = {true} />
          <h1 className='EventValuesH1'>Manufacturers {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
          <ManufacturerRegisterHistoryTable registers = {this.props.manufacturerRegisters} instance = {this.props.instance} isHistory = {true} />
          <h1 className='EventH1'>Events History  {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
            <EventsHistoryTable events = {  this.handleSort(this.props.events)} instance = {this.props.instance} isHistory = {true} />
            <EventsChart selected={this.state.selected} handleChange = {this.handleChange} events = {this.props.events}  theme = {createMuiTheme({...themes.default, ...overrides})} />
        </div>
      );
    }else if(this.props.match.params.tag.includes("well-latesttag")){
      return (
        <div  className='EventsTable-Wrapper'>
          <h1 className='EventValuesH1'>Values History {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
          <RegisterHistoryTable registers = {this.props.registers} instance = {this.props.instance} isHistory = {true} />
          <h1 className='EventValuesH1'>Realtime Data Feeds {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
          <RealtimeDatafeedTable registers = {this.props.realtimeFeedsRegisters} instance = {this.props.instance} isHistory = {true} />
          <h1 className='EventH1'>Events History  {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
            <EventsHistoryTable events = {  this.handleSort(this.props.events)} instance = {this.props.instance} isHistory = {true} />
            <EventsChart selected={this.state.selected} handleChange = {this.handleChange} events = {this.props.events}  theme = {createMuiTheme({...themes.default, ...overrides})} />
        </div>
      );
    }else{
      return (
        <div  className='EventsTable-Wrapper'>
          <h1 className='EventValuesH1'>Values History {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
          <RegisterHistoryTable registers = {this.props.registers} instance = {this.props.instance} isHistory = {true} />
          <h1 className='EventH1'>Events History  {this.props.instance !== undefined && this.props.instance !== null ? ' - '+this.props.instance.name : ' '}</h1>
            <EventsHistoryTable events = {  this.handleSort(this.props.events)} instance = {this.props.instance} isHistory = {true} />
            <EventsChart selected={this.state.selected} handleChange = {this.handleChange} events = {this.props.events}  theme = {createMuiTheme({...themes.default, ...overrides})} />
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  requestEventsTagInstance: (instanceId, tag, days) => dispatch(actionCreators.requestEventsTagInstance(instanceId, tag, days)),
  requestRegistersTagInstance: (instanceId, tag) => dispatch(actionCreatorsRegisters.requestRegistersTagInstance(instanceId, tag)),
  requestManufacturerCommsFailureRegisters: (instanceId) => dispatch(actionCreatorsRegisters.requestManufacturerCommsFailureRegisters(instanceId)),
  requestRealtimeDatafeedRegisters: (instanceId) => dispatch(actionCreatorsRegisters.requestRealtimeDatafeedRegisters(instanceId)),
});

const mapStateToProps = (state, props) => {
  return {
    events: state.events.eventsInstance,
    registers: state.registers.registersInstance,
    manufacturerRegisters: state.registers.manufacturerRegisters,
    realtimeFeedsRegisters: state.registers.realtimeFeedsRegisters,
    instance: state.instances.instances.find(
      instance => instance.id+"" === props.match.params.id
      )
  };
}

const EventInstanceHistory = connect(
  mapStateToProps,
  mapDispatchToProps
)(EventInstanceHistoryComponent);

export default EventInstanceHistory;


// WEBPACK FOOTER //
// ./src/components/EventInstanceHistory.js